<template>
  <div id="app">
    <headerComponents></headerComponents>
    <router-view></router-view>
    <footerComponents></footerComponents>
  </div>
</template>

<script>
import headerComponents from '../src/components/header'
import footerComponents from '../src/components/footer'

export default {
  components: {
    headerComponents,
    footerComponents
  },
  data() {
    return {}
  },
  created() {
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  methods: {
    initCNZZ() {
      const script = document.createElement('script')
      script.src = "https://w.cnzz.com/c.php?id=1281053692&l=3"
      script.id = 'cnzz'
      document.body.appendChild(script)
    }
  },
  mounted() {
    this.initCNZZ();
  },
  watch: { // 路由变化时发送统计
    '$route': {
      handler() {
        setTimeout(() => {
          if (window._czc) {
            let location = window.location
            let contentUrl = location.pathname + location.hash
            let refererUrl = '/'
            window._czc.push(['_setAutoPageview', false])
            window._czc.push(['_trackPageview', contentUrl, refererUrl])
          }
        }, 300)
      },
      // 页面第一次加载的时候就执行
      immediate: true
    }
  }
}

</script>

<style lang="less">
body {
  margin: 0;
}

input, textarea {
  outline: none;
  resize: none;
  font-family: 微软雅黑;
}

a {
  text-decoration: none;
}

.hide {
  display: none !important;
}

.show {
  display: block;
}

#app {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.pageBox {
  min-height: 500px !important;
}

img,table{
    max-width: 100%;
    margin: 0 auto;
}

/* table 样式 */
table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

table td,
table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}

table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}

/* blockquote 样式 */
blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}

/* code 样式 */
code {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}

pre code {
  display: block;
}

/* ul ol 样式 */
ul, ol {
  margin: 10px 0 10px 20px;
}
</style>
